import { ReactElement } from 'react';

import { Typography } from '@/shared/components/atoms';

const AlertDetailRecord = ({
  label,
  value,
  Icon,
}: {
  label: string;
  value: string;
  Icon: ReactElement;
}) => {
  // const {t}=useTranslation('common')
  // const [isTruncated, setIsTruncated] = useState(false);
  // const toggleIsTruncated = () => {
  //   setIsTruncated(!isTruncated);
  // };
  return (
    <div className='flex  gap-8'>
      <div className=''>{Icon}</div>
      <div className='flex  flex-col gap-px '>
        <Typography variant='caption' className='text-surface-10 '>
          {label}
        </Typography>
        <Typography
          variant='body2'
          //  className={`overflow-hidden relative ${isTruncated ? 'line-clamp-2' : 'line-clamp-none'}`}
        >
          {value}
          {/* {isTruncated && (
            <button
              onClick={toggleIsTruncated}
              className="text-blue-500 absolute right-0 bottom-0 bg-white px-2"
            >
             {t('show-more')}
            </button>
          )} */}
        </Typography>
      </div>
    </div>
  );
};

export { AlertDetailRecord };
